import classNames from 'classnames';
import {useState} from 'react';

import {TypographySize, useTypography} from '@time-webkit/all/hooks/typography';
import {ContentCopy} from '@time-webkit/all/icons/content-copy';
import {CheckIcon} from '@time-webkit/all/icons/check';

import styles from './styles.module.css';

type Props = {
    className?: string;
    text: string;
    onClickCopy?: (text: string) => void;
};

export const CopyBox: React.FC<Props> = ({className, text, onClickCopy}) => {
    const [copied, setCopied] = useState(false);
    const textStyle = useTypography({size: TypographySize.BodyL});

    const handleClick = () => {
        onClickCopy?.(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div
            className={classNames(styles.container, textStyle, className)}
            onClick={handleClick}
        >
            <span>{text}</span>
            <span className={classNames(styles.icon, {[styles.check]: copied})}>
                {copied ? (
                    <CheckIcon
                        width={16}
                        height={16}
                    />
                ) : (
                    <ContentCopy
                        width={16}
                        height={16}
                    />
                )}
            </span>
        </div>
    );
};
